import { ShortMediaInfo } from '.';

export interface Phrase {
  phrase: string;
  explanation?: string;
  ts?: number;
  id?: string;
}

export type CardLearningStatus = 'remembered' | 'not_remembered';

export interface WordData {
  id: string;
  word: string;
  transcription: string;
  definition: string;
  example_phrases: Phrase[];
  learningStatus?: CardLearningStatus;
  saved?: boolean;
}

export interface PhrasesResponse {
  words: WordData[];
  part: number;
  totalParts: number;
  wordBatchId: number;
  screenmediaId: string;
  mediaTitle?: string;
  mediaPoster?: string;
  nextPart?: number;
  previewPending?: boolean;
  previewTargetSize?: number;
  previewRemainderPart?: number;
  error?: string;
}

export interface WordAndPhrases {
  id: string;
  word: string;
  phrases: Phrase[];
}

export interface SaveWordRequest {
  wordData: WordData;
  wordBatchId?: number;
  screenmediaId?: string;
  metadata?: ShortMediaInfo;
  collectionId?: string;
}

export interface SaveWordResponse {
  id: string;
  collectionId: string;
  created: boolean;
}

export interface SavedWordData extends WordData {
  savedData: {
    id: string;
    wordBatchId?: number;
    screenmediaId?: string;
    metadata?: ShortMediaInfo;
  };
}

export interface CollectionWordsResponse {
  words: SavedWordData[];
  part: number;
  totalParts: number;
  collectionId: string;
  collectionName: string;
  collectionDescription?: string | null;
  error?: string;
}

export enum WordBatchStatus {
  Ready = 'ready',
  Processing = 'processing',
  Error = 'error',
  Created = 'created'
}
